import { render, staticRenderFns } from "./FiCustomFieldItem.vue?vue&type=template&id=e52fecfa&lang=pug&"
import script from "./FiCustomFieldItem.vue?vue&type=script&lang=js&"
export * from "./FiCustomFieldItem.vue?vue&type=script&lang=js&"
import style0 from "./FiCustomFieldItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports